import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../../../../../media';

export const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	column-gap: 16px;
	${media.mobile} {
		flex-direction: column;
		align-items: flex-start;
		row-gap: 20px;
	}
`;

export const HeaderBtnsWrapper = styled.div`
	display: flex;
	column-gap: 25px;
`;

export const FilterBtnWrapper = styled.div`
	position: relative;
`;

export const FilterBtnStyles = css`
	display: none;
	${media.tablet} {
		display: flex;
		padding-inline: 22px;
		& > span {
			column-gap: 8px;
		}
	}
`;

export const BadgeStyles = css`
	position: absolute;
	top: -10px;
	right: -10px;
	padding: 2px 4px;
	& > span {
		font-size: 11px;
	}
`;
